import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { globals } from 'src/app/globals';
import { CRMOportunidadeAnexo } from 'src/app/models/crm/crmoportunidade-anexo';

@Injectable({
  providedIn: 'root'
})
export class CrmoportunidadeAnexoService {

  constructor(private http: HttpClient) { }

  consultarOportunidadeAnexos() {
    return this.http.get<CRMOportunidadeAnexo[]>(globals.apiUrl + '/api/CRMOportunidadeAnexo/Lista');
  }

  consultarOportunidadeAnexosComPaginacao(idOportunidade, descri: string, paginaAtual, qtdRegistros, campoOrdenacao, orientacaoOrdenacao) {

    let parametros = new HttpParams()
      .set('pag', paginaAtual)
      .set('qt', qtdRegistros)
      .set('ordem', campoOrdenacao)
      .set('asc_desc', orientacaoOrdenacao)
      .set('idOportunidade', idOportunidade);

    if (descri.trim() !== '') {
      parametros = parametros.set('descri', descri);
    }

    return this.http.get<any>(globals.apiUrl + '/api/CRMOportunidadeAnexo/ListaPag',
      {
        params: parametros
      });
  }

  consultarPorIdOportunidadeAnexo(id) {
    return this.http.get<any>(globals.apiUrl + '/api/CRMOportunidadeAnexo/Buscar',
      { params: new HttpParams().set('id', id) });
  }

  salvar(oportunidadeAnexo) {
    return this.http.post(globals.apiUrl + '/api/CRMOportunidadeAnexo/Salvar', oportunidadeAnexo);
  }

  excluir(id) {
    return this.http.delete(globals.apiUrl + '/api/CRMOportunidadeAnexo/Excluir',
      { params: new HttpParams().set('id', id) });
  }
}
